export const UserBase = ({
  first_name = '',
  last_name = '',
  email = '',
  roles = ['user'],
  notes = '',
  registry_ids = [],
}) => ({
  first_name,
  last_name,
  email,
  roles,
  notes,
  registry_ids,
})
